import { render, staticRenderFns } from "./ArrowSignIcon.vue?vue&type=template&id=1dd05381&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd05381",
  null
  
)

export default component.exports